import { FORMULA_TYPE } from '@/utils/constants/examConstants'

function isAttributeFormulaPerType(typeAttribute) {
	return typeAttribute === FORMULA_TYPE
}

export { isAttributeFormulaPerType }
